import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import '../../content/css/EditableTextArea.css';
import ReactMarkdown from 'react-markdown';
import HighlightTextBox from '../Highlight/HighlightTextBox';
import MissingConceptTextBox from '../MissingConcepts/MissingConceptTextBox';

export const displayType = {
    EDITOR: "EDITOR",
    RESULT: "RESULT"
}

export default class EditableMarkdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            markdown: props.markdown || "",
            display: displayType.RESULT
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        var self = this;
        if (prevProps.markdown !== this.props.markdown) this.setState({ markdown: self.props.markdown || "" });
    }

    handleChange = e => {
        this.setState({ markdown: e.target.value });
    }

    handleSave = () => {
        this.setState({ display: displayType.RESULT });
        this.props.onSave(this.state.markdown);
    }

    handleEdit = () => {
        this.setState({ display: displayType.EDITOR });
    }

    handleButtonClick = () => {
        if (this.state.display == displayType.EDITOR) this.handleSave();
        else this.handleEdit();
    }

    getPreviewHighlight = () => {
        return {
            feedbackGuidance: this.props.activeTab === 'guidance' ? this.state.markdown : '',
            feedbackExamples: this.props.activeTab === 'examples' ? this.state.markdown : '',
            feedbackExplanation: this.props.activeTab === 'explanation' ? this.state.markdown : '',
            feedbackApproval: this.props.activeTab === 'approval' ? this.state.markdown : '',
            categoryName: this.props.title,
            isActive: true,
            isSelected: true
        };
    }

    createTextBox = () => {
        if (this.props.style === "missing concept") {
            return (<div className="missing-concepts preview">
                <MissingConceptTextBox title={this.props.title} text={this.state.markdown} />
            </div>);
        }
        else {
            return (<div className="clause-info-list preview">
                <HighlightTextBox
                    highlight={this.getPreviewHighlight()}
                    index={0}
                    highlightsCount={1}
                    isMinimized={false}
                    visibility={"visible"}
                    isAdmin={false}
                    activeTab={this.props.activeTab}
                    top={0}
                />
            </div>);
        }
    }

    render() {
        let btnText = this.state.display == displayType.EDITOR ? "Save" : "Edit";

        return (
            <div className="editable-markdown">
                <div className="content">
                    {this.state.display == displayType.EDITOR &&
                        <div className="editor">
                            <textarea value={this.state.markdown} onChange={this.handleChange} />
                        </div>
                    }
                    {this.state.display == displayType.RESULT &&
                        <div>
                            <ReactMarkdown classname="box-content" source={this.state.markdown} escapeHtml={false} />
                        </div>
                    }
                    {this.props.showPreviewBox &&
                        <div className="preview-box">
                            {this.createTextBox()}
                        </div>
                    }
                </div>
                <Button className="save-btn" onClick={this.handleButtonClick}>{btnText}</Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/EditableMarkdown.js